import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DoneIcon from "@mui/icons-material/Done";
import { MenuItem, MenuList } from "@mui/material";

import { SettingsAction } from "./ButtonSettings";
import {
  AutoResolutionText,
  ListContainer,
  StyledListItemText,
  StyledPaper,
  StyledTypography,
} from "./ButtonSettings.elements";

type SettingMenuProps = {
  setting: SettingsAction[];
  handleSettingsMenuBack: () => void;
};

export default function SettingsMenu({ setting, handleSettingsMenuBack }: SettingMenuProps): React.ReactElement {
  return (
    <ListContainer id={setting[0].id}>
      <StyledPaper>
        <MenuList>
          <MenuItem key={setting[0].displayName} onClick={handleSettingsMenuBack}>
            <ArrowBackIosIcon sx={{ color: "white", fontSize: "0.75rem" }} />
            <StyledListItemText sx={{ paddingLeft: "8px" }}>{setting[0].displayName}</StyledListItemText>
          </MenuItem>
          {setting[0].values.map(value => (
            <MenuItem key={value.display} onClick={() => setting[0].handler(value)}>
              <StyledListItemText>
                {value.display}
                {value.autoResolutionText && <AutoResolutionText>{value.autoResolutionText}</AutoResolutionText>}
              </StyledListItemText>
              {setting[0].selectedValue === value.display && (
                <StyledTypography>
                  <DoneIcon />
                </StyledTypography>
              )}
            </MenuItem>
          ))}
        </MenuList>
      </StyledPaper>
    </ListContainer>
  );
}
